module.exports = __webpack_public_path__ + "static/media/elife-school-2024-9.56d2e174.gif";